import { useEffect, useMemo, useState } from "react";
import { useIntl } from "react-intl";
import { buildSnapshotFromTemplate } from "utils/deliveryNoteHelper";
import { getDeliveryNoteImageQuery } from "api/delivery-note/queries";

const useDeliveryNoteDocumentImages = (template) => {
  const intl = useIntl();
  const [imageUrlByFileId, setImageUrlByFileId] = useState({});

  const snapshot = useMemo(
    () => buildSnapshotFromTemplate({ template, intl }),
    [template, intl]
  );

  const fileIds = useMemo(
    () =>
      [
        snapshot?.issuer_logo_file_id,
        snapshot?.recipient_logo_file_id,
        snapshot?.issuer_signature_file_id,
        snapshot?.recipient_signature_file_id,
      ].filter(Boolean),
    [snapshot]
  );

  useEffect(() => {
    if (!fileIds.length) return undefined;
    let isCurrent = true;
    Promise.all(
      fileIds.map((fileId) =>
        getDeliveryNoteImageQuery({ fileId })
          .then((url) => [fileId, url])
          .catch(() => [fileId, ""])
      )
    ).then((pairs) => {
      if (isCurrent) setImageUrlByFileId(Object.fromEntries(pairs));
    });
    return () => {
      isCurrent = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fileIds.join("|")]);

  const resolveImage = (fileId) => (fileId && imageUrlByFileId[fileId]) || "";

  const areImagesReady = fileIds.every((fileId) =>
    Object.hasOwn(imageUrlByFileId, fileId)
  );

  return { snapshot, resolveImage, areImagesReady };
};

export default useDeliveryNoteDocumentImages;
